import styled from 'styled-components';
import { defaultPagePadding } from '../StudentPage/StudentPage.styled';
import { studentTopbarHeight } from '@/shared/StudentPage/StudentPageTopbar/StudentPageTopbar.styled';
import Colors from '@/constants/Colors';

export const StyledTaskActivityDetail = styled.div`
  height: 100%;
  position: relative;

  .ant-spin-nested-loading,
  .ant-spin-container {
    height: 100%;

    .task-activity-container {
      display: flex;
      height: 100%;

      .activity-detail {
        flex: 2;
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: ${defaultPagePadding};

        .activity-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;

          .subtitle {
            font-weight: bold;
          }
        }
        .activity-container {
          flex: 1;
          height: 0;

          > div {
            height: 100%;
          }
        }
      }

      .activity-nav {
        flex: 1;
        height: calc(var(--appheight) - ${studentTopbarHeight});
        overflow-y: auto;
        box-shadow: 0px 1px 4px ${Colors.boxShadowBlack};
        background-color: white;
      }
    }
  }
`;
